<div data-target="verifyEmail" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>
      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'PAGE_HEADING' | translate }}
        </h1>

        <p class="dt-l-article__section__description" *ngIf="isVerified === VERIFYSTATE.LOADING">
          {{ 'PAGE_SUBHEADING_LOADING' | translate }}
        </p>

        <p
          class="dt-l-article__section__description"
          *ngIf="isVerified === VERIFYSTATE.OK"
          [innerHtml]="pageSubheadingOk"></p>

        <p class="dt-l-article__section__description" *ngIf="isVerified === VERIFYSTATE.ERROR">
          {{ 'PAGE_SUBHEADING_ERROR' | translate }}
        </p>

        <button class="dt-c-button block primary" type="button" (click)="routeToLogin()">
          {{ 'BACK_TO_APP' | translate }}
        </button>
      </section>
    </div>
  </article>
</div>
